import { AppState } from 'redux/reducers';

export const getEventInfo = ({ event }: AppState) => event.eventInfo;
export const getEventLoading = ({ event }: AppState) => event.loading;
export const getStartDate = ({ event }: AppState) => event.startDate;
export const getRulesLoading = ({ event }: AppState) => event.rulesLoading;
export const getRules = ({ event }: AppState) => event.rules;
export const getEventGroup = ({ event }: AppState) => event.eventGroup;
export const getEventMarkets = ({ event }: AppState) => event.marketCatalogues;
